import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

export function Spinner({ className, size = 28 }: { className?: string; size?: number }) {
	return <Loader2 className={cn('animate-spin text-primary', className)} size={size} />;
}

export function PageSpinner({ minHeight = '40vh' }: { minHeight?: string }) {
	return (
		<div className="flex items-center justify-center" style={{ minHeight }}>
			<Spinner />
		</div>
	);
}
